module.exports = __webpack_public_path__ + "img/new-logo.fb06d3dc.svg";